import makeStyles from "@mui/styles/makeStyles";
import { Bold, SemiBold } from "../../utils";
export const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: theme.palette.borderRadius,
        boxShadow: "0px 0px 16px #00000014",
        backgroundColor: "white",
        padding: "16px",
    },
    logo_div: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginInlineEnd: "16px"
    },
    logo: {
        height: "75px",
        width: "75px",
        borderRadius: "50%",
        objectFit: "fill"
    },
    title_div: {
        display: "flex",
        marginBottom: "10px",
        alignItems: "center",
        marginInlineStart: "16px"
    },
    title: {
        color: theme.typography.color.secondary,
        fontSize:"0.75rem",
        fontFamily: Bold,
    },
    title_tag: {
        margin: "0px 8px",
        padding: "1px 8px",
        borderRadius: "4px",
        backgroundColor: "#071741",
        color: "white",
        fontSize:"0.75rem",
        fontFamily: SemiBold,
        display: "inline",
    },
    heading: {
        color: theme.typography.color.tertiary,
        fontSize:"0.875rem",
        fontFamily: SemiBold,
        textTransform: "capitalize"
    },
    content: {
        color: theme.typography.color.primary,
        fontSize:"0.875rem",
        fontFamily: SemiBold,
        textTransform: "capitalize",
        '& .ql-editor': {
            padding: '0px 0px 16px 0px',
            color: theme.typography.color.primary,
            fontSize:"0.875rem",
            fontFamily: SemiBold,
            textTransform: "capitalize",
            textAlign: "start"

        }
    },
    image_viewer: {
        '& .styles-module_close__2I1sI': {
            color: 'white',
            position: 'absolute',
            top: '67px',
            right: '100px',
            fontSize: '40px',
            fontWeight: 'bold',
            opacity: 0.2,
            cursor: 'pointer',
        }
    },
}));